<template>
  <div class="about">
  <div class="heade">
    <van-button plain type="default" size="small" @click="back()">返回</van-button>
    <van-button plain type="default" size="small" @click="subMit()">提交</van-button>
  </div>
  <div class="successTitle">
    <!-- <van-image width="30" height="30" :src="icons"/> -->
    <p>编辑信息</p>
  </div>
  <!-- <van-cell-group v-for="(item, index) in dataList" :key="index">
    <div v-if="item.attr_code == 'file' " class="fileInput">
      <p>{{item.attr_name}}:</p>
      <van-image
        width="20"
        height="20"
        fit="contain"
        :src="item.value"
      />
    </div>
    <van-field v-else-if="item.attr_code == 'description'" readonly v-model="item.value" :label="item.attr_name" type="textarea"/>
    <div v-else-if="item.attr_code == 'image'" class="imgInput">
      <p>{{item.attr_name}}:</p>
      <van-image
        width="50"
        height="50"
        fit="contain"
        :src="item.value"
      />

    </div>
    
    <van-field v-else v-model="item.value" readonly :label="item.field_name"/>
  
  </van-cell-group> -->
    <editWorld :msg=item ref="child"  v-for="(item, index) in dataList" :key="index"></editWorld>
  </div>
</template>
<script>
import { information, edit } from '@/api/login/login.js';
import {getInfo, getSchool, removeSchoolItem, removeSchool, removeToken, getSchoolItem, setToken, setInfo} from '@/utils/auth.js';
import { mapGetters, mapMutations } from 'vuex';
import  areaList  from '@/assets/js/area.js'
import icons from '@/assets/icon_sucess.png';
import editWorld  from '@/components/editWorld';
export default {
  components:{
      editWorld
  },
  data(){
    return {
      dataList:[],
      icons
    }
  },
  created(){
    this.getInformation()
  },
  methods:{
    /**
     * 获取个人信息
     * @method getInformation
     */
    getInformation(){
      let obj = JSON.parse(getInfo());
      let formData = new FormData();
      formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id, 'stu_id':obj.stu_id}));
      information(formData).then( res => {
        if (res.code == 0) {
          res.data.forEach(item => {
            if(item.attr_code == 'region'){
              if(item.value != ''){
                item.value = [
                  {name:areaList.province_list[item.value[0]], code:item.value[0]},
                  {name: areaList.city_list[item.value[1]], code:item.value[1]},
                  {name:areaList.county_list[item.value[2]], code:item.value[2]}];
              }
            }
          });
          this.dataList = res.data;
        }else {
          this.$toast(res.msg);
        }
      }).catch(error=>{
        this.$toast('请联系管理员');
      })
    },
    /**
     * 退出btn
     * @method back
     */
    back(){
      this.$router.push({path:'/', query:{code: this.$route.query.code}})
    },
        /**
         * 表单提交方法
         * @method subMit
         */
        subMit () {
          this.params = [];
          this.$refs.child.forEach(item=>{
            this.params.push({template_field_id: item.msg.template_field_id,value:item.newValue})
          })
          let formData = new FormData();
          formData.append('request', JSON.stringify({'project_id': JSON.parse(getSchool()).project_id, 'campus':getSchoolItem(), 'params': this.params}));
          edit(formData).then(res => {
            if(res.code == 0){
              setToken(res.data.token)
              setInfo(JSON.stringify(res.data))
              this.$toast.success('编辑成功');
              this.$router.push({path:"/", query:{code: this.$route.query.code}});
            }else {
              this.$toast.fail(res.msg);
            }
          }).catch( error => {
              console.log('@/views/edit.vue 编辑表单' + error )
          })
        },
  },
  computed: {
    ...mapGetters([
      'schoolItem',
      'school'
    ]),
  }
}
</script>
<style lang="scss" scoped>
.imgInput{
  display: flex;
  align-items:center;
  border: none;
  padding: 10px 0;
  p{
    font-size:14px; 
    margin: 10px 32px 10px 16px;
  }
}
.fileInput{
  display: flex;
  align-items:center;
  border: none;
  padding: 10px 0;
  p{
    font-size:14px; 
    margin: 10px 32px 10px 16px;
  }
}
.heade{
  padding: 0 20px;
  height: 40px;
  width: calc(100% - 40px);
  border: 1px solid #f3f3f3;
  display: flex;
  justify-content: space-between;
  align-items: center;

}
.successTitle{
  padding: 0 10px;
  height: 120px;
  width: calc(100% - 20px);
  border: 1px solid #fff;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p{
    margin-top: 10px;
  }
}
</style>